module.exports = __webpack_public_path__ + "static/img/plain.c999629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plain.png
// module id = BB81
// module chunks = 2